/*******************************************************************************************
 *Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  displaySCMCard.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date          : 03 Nov 2020
 *
 * @Version      : Version 1.0
 *
 *******************************************************************************************/

import * as React from 'react';
import{ Grid, Card, Icon, Input} from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './ConfigureProduct.css';


export function DisplaySCMCard(props: any) {
    return (
        <Card className="fullwidthCard">
            <Card.Content>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={11} className="fullwidthRow">
                            <span className="cp-serial-title-text"> ADDED SERIAL NUMBER</span>
                        </Grid.Column>
                        <Grid.Column width={1} className="fullwidthRow">
                        <div className="cp-conf-edit"><Icon root="common" name="edit" size="small"
                                                            onClick={props.gotoSCMSerialNumbersTab} /></div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid id="inputBoxes" className="cp-confirmConfigurationTab">
                {props.SCMSerialNumbers.map((row) =>
                <Grid.Row key={row.serialNumber}>
                       <Grid.Column width={7} className="padd-left-0">
                             <Input
                                 key={row.serialNumber}
                                 className="input-example"
                                 value={row.serialNumber}
                             />
                         </Grid.Column>
                     </Grid.Row>
                )
            }
                </Grid>
            </Card.Content>
        </Card>
    );
}